<template>
  <div class="group-edit-container">
    <el-form class="user-from" ref="editForm" :model="setInfo" :rules="rules" label-width="130px" >
      <el-form-item label="组别名称">
        <el-input
          required
          v-model="setInfo.name"
          placeholder="请输入名称"/>
      </el-form-item>
      <el-form-item label="参赛球队数量">
        <el-input
          v-model="setInfo.teamCount"
          placeholder="请输入数值"/>
      </el-form-item>
      <el-form-item label="射手榜显示数量">
        <el-input
          v-model="setInfo.topScorerCount"
          placeholder="请输入数值"/>
      </el-form-item>
      <!--<el-form-item label="每局时间(分钟)">-->
        <!--<el-input-->
          <!--v-model="setInfo.sectionDurationMinutes"-->
          <!--placeholder="请输入数值"/>-->
      <!--</el-form-item>-->
      <el-form-item label="排序">
        <el-input
          v-model="setInfo.seq"
          placeholder="请输入名称"/>
      </el-form-item>
      <el-form-item label="状态" >
        <el-radio-group v-model="setInfo.status">
          <el-radio :label="0">正常</el-radio>
          <el-radio :label="-1">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="允许主教练带领多支球队">
        <el-switch
          v-model="coachTeamRestrictMode"
          active-color="#409EFF"
          inactive-color="#ccc">
        </el-switch>
      </el-form-item>
      <el-form-item>
        <!--<el-button type="info" plain>返回</el-button>-->
      </el-form-item>
    </el-form>
    <el-button :loading="userLoding" type="primary" @click="submitForm('editForm')" >提交</el-button>
  </div>
</template>

<script>
import { varConfig, showMessage, ImageFormat, ConstConfig } from '@/utils'
import { getQiniuUploadToken } from '@/api/site'
import { getMatchInfo, updateMatchInfo, createMatchGroup, getMatchGroup, updateMatchGroup } from '@/api/match'
export default {
  name: 'LeagueGroupEdit',
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      sex: null,
      dataObj: { token: '' },
      qiniuUp: varConfig.qiniuUp,
      accept: ConstConfig.accept,
      setInfo: {
          status: 0
      },
      checkList: [],
      userLoding: false,
      playerTeamRestrictMode: false,
      coachTeamRestrictMode: false,
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ]
      },
      routerParams: {}
    }
  },
  created() {
    this.routerParams = this.$route.params
    const routerQuery = this.$route.query
    if(routerQuery.gid) {
      this.routerParams.gid = routerQuery.gid
      this.getInfo()
    }
  },
  mounted() {},
  methods: {
    getInfo() {
      const params = { id: this.routerParams.gid }
      getMatchGroup(params).then((resolve) => {
        if (!resolve.data) {
          return
        }
        const info = this.setInfo = resolve && resolve.data.group
        if (info.playerTeamRestrictMode === 0 || info.playerTeamRestrictMode === '0') {
          this.playerTeamRestrictMode = false
        } else {
          this.checkList = info.playerTeamRestrictMode.split('|')
          this.playerTeamRestrictMode = this.checkList.every((item) => {
            return item !== 0
          })
        }
        if (info.coachTeamRestrictMode === 0 || info.coachTeamRestrictMode === '0') {
          this.coachTeamRestrictMode = false
        } else if (info.coachTeamRestrictMode === 1) {
          this.coachTeamRestrictMode = true
        }
      })
    },
    newGroup() {
      this.userLoding = true
      this.setInfo.matchId = this.routerParams.id
      if (this.playerTeamRestrictMode) {
        this.setInfo.playerTeamRestrictMode = JSON.stringify(this.checkList)
      }
      if (this.coachTeamRestrictMode) {
        this.setInfo.coachTeamRestrictMode = 1
      }
      createMatchGroup(this.setInfo).then((res) => {
        this.userLoding = false
        const data = res.data
        if(data) {
          this.$message({
            message: '创建成功',
            type: 'success'
          })
          this.$router.push({
            name: 'LeagueGroups',
            params: {
              id: this.routerParams.id
            }
          })
        }
      })
    },
    updateGroup() {
      this.userLoding = true
      if (this.coachTeamRestrictMode === false) {
        this.setInfo.coachTeamRestrictMode = 0
      } else if (this.coachTeamRestrictMode === true) {
        this.setInfo.coachTeamRestrictMode = 1
      }

      if (this.playerTeamRestrictMode === false) {
        this.setInfo.playerTeamRestrictMode = 0
      } else {
        if (this.checkList.length) {
          this.setInfo.playerTeamRestrictMode = this.checkList.join('|')
        } else {
          this.setInfo.playerTeamRestrictMode = 0
        }
      }

      updateMatchGroup(this.setInfo).then((resolve) => {
        this.userLoding = false
        if (resolve) {
          this.$message({
            message: '修改详情成功',
            type: 'success'
          })
        }
      })
    },
    submitForm(formName) {
      this.routerParams = this.$route.params
      if(this.routerParams.gid) {
        this.updateGroup()
      } else {
        this.newGroup()
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .group-edit-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .upload-size .el-upload {
      width: 80px;
      height: 80px;
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 78px;
      height: 78px;
      line-height: 78px !important;
      text-align: center;
      position: absolute;
      top: 0;
      left: 0;
    }

    .upload-size .el-upload:hover {
      border-color: #409EFF;
    }

    .upload-size .el-upload-list li {
      width: 80px;
      height: 80px;
    }

    .user-from .el-form-item__label {
      text-align: left;
      padding-left: 15px;
    }

    .certificate-upload-style {
      width: 120px;
      height: 32px;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      color: #999999;
      line-height: 32px;
    }

    .font-size-style {
      font-size: 14px;
      color: #169BD5;
      padding-left: 20px;
    }

    .team-info-width {
      width: auto;
      margin-right: 12px;
    }

    .el-upload img {
      width: 78px;
      height: 78px;
    }
  }
</style>
